import React from 'react';

export type WrapperElementFunction = (children: React.ReactNode) => React.ReactElement;

interface LinkElementProps extends React.HTMLProps<HTMLAnchorElement> {
  element?: WrapperElementFunction;
}

interface ButtonElementProps extends React.HTMLProps<HTMLButtonElement> {
  element?: WrapperElementFunction;
}

interface DivElementProps extends React.HTMLProps<HTMLDivElement> {
  element?: undefined;
}

type WrapperElementProps = LinkElementProps | ButtonElementProps | DivElementProps;

export function WrapperElement({
  element = undefined,
  children = undefined,
  ...passthroughProps
}: React.PropsWithChildren<WrapperElementProps>) {

  if (!children) return null;

  if (element) {
    return React.cloneElement(element(children), { ...passthroughProps });
  }

  return React.cloneElement(<div />, { ...passthroughProps });
}
